const { pluck } = require('ramda')

const holidayRegions = [
  { label: 'None', value: 'none' },
  { label: 'USA', value: 'US' },
  { label: 'Canada', value: 'CA' },
  { label: 'Philippines', value: 'PH' },
]

const holidayRegionCodes = pluck('value', holidayRegions)

module.exports = { holidayRegions, holidayRegionCodes }
